export default {
  // Estado de la rutina
  status: {
    created: 'In Editing',
    scheduled: 'Scheduled',
    extended: 'Scheduled',
    rescheduled: 'Scheduled',
    active: 'Active',
    finished: 'Finished'
  },

  // Periodicidad (forma corta y forma larga/adverbial)
  periodicity: {
    daily: 'daily',
    weekly: 'weekly',
    monthly: 'monthly',
    daily_long: 'daily',
    weekly_long: 'weekly',
    monthly_long: 'monthly'
  },
  preview: {
    usersAdded: '{count} new user(s) will be added.',
    usersRemoved: '{count} user(s) will be removed.',
    activitiesToGenerate: 'Approximately {count} new activity(ies) will be generated.',
    activitiesToDelete: '{count} scheduled activity(ies) will be deleted.',
    usersExcluded: '{users} user(s) will not be added to {activities} days-and-hours activity(ies): ' +
      'they have several locations (or none) in the role. Assign their location in each activity.'
  }
}
